export enum ScreenEnum {
	launch,
	welcome,
	setSecond,
	hardwareCheck,
	softwareCheck,
	selectMarket,
	validation,
	pairDevice,
	selectDevice,
	validationDevice,
	password,
	final,
	exit,
	exitNoCancel,
}
